import {
  Card,
  Group,
  ActionIcon,
  BackgroundImage,
  Checkbox,
  Box,
} from "@mantine/core";
import { IconDownload, IconTrash } from "@tabler/icons-react";
import { useState } from "react";
import { useHover, useMediaQuery } from "@mantine/hooks";

export function GalleryImageCard({
  image,
  onClick,
  onDelete,
  checked,
  onCheckedChange,
  selectionMode,
  mah = 400,
}) {
  const [isDeleting, setIsDeleting] = useState(false);
  const { hovered, ref } = useHover();
  const isMobile = useMediaQuery("(max-width: 50em)");

  var imageUri = image?.pixelImages?.find(
    (img) => img.type === "Thumbnail"
  )?.uri;
  var fullsizeUri = image?.pixelImages?.find(
    (img) => img.type === "Original"
  )?.uri;

  return (
    <Card
      withBorder
      shadow="sm"
      radius="md"
      onClick={() => {
        selectionMode ? false : onClick();
      }}
      style={{ cursor: "pointer" }}
      ref={ref}
    >
      <Card.Section>
        <BackgroundImage src={imageUri} radius="sm">
          <Box mah={mah} style={{ height: `${mah}px` }}>
            {selectionMode || isMobile || hovered ? (
              <Group
                justify="space-between"
                style={{ bottom: 0, position: "absolute", width: "100%" }}
                bg="rgba(0.5,0.5,0.5,0.7)"
                p="xs"
                onClick={(e) => e.stopPropagation()}
              >
                <Checkbox
                  checked={checked}
                  onChange={(event) =>
                    onCheckedChange(event.currentTarget.checked)
                  }
                  radius="xl"
                  size="md"
                />
                <Group>
                  <ActionIcon
                    variant="outline"
                    loading={isDeleting}
                    onClick={() => {
                      setIsDeleting(true);
                      onDelete(image.logicalImageId);
                    }}
                  >
                    <IconTrash size={18} />
                  </ActionIcon>

                  <ActionIcon
                    component="a"
                    variant="outline"
                    target="_blank"
                    href={fullsizeUri}
                    aria-label="Download"
                  >
                    <IconDownload size={18} />
                  </ActionIcon>
                </Group>
              </Group>
            ) : null}
          </Box>
        </BackgroundImage>
      </Card.Section>
    </Card>
  );
}
